export default "__VITE_ASSET__225a52d1__"